import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["primaryColor", "primaryColorText", "secondaryColor", "secondaryColorText", "accentColor", "accentColorText", "logo", "continueBtn"]

  connect() {
    this.validateFields()
    // Sync color pickers and text inputs both ways
    if (this.hasPrimaryColorTarget && this.hasPrimaryColorTextTarget) {
      this.primaryColorTarget.addEventListener("input", () => {
        this.primaryColorTextTarget.value = this.primaryColorTarget.value
      })
      this.primaryColorTextTarget.addEventListener("input", () => {
        if (/^#[0-9A-Fa-f]{6}$/.test(this.primaryColorTextTarget.value)) {
          this.primaryColorTarget.value = this.primaryColorTextTarget.value
        }
      })
    }
    if (this.hasSecondaryColorTarget && this.hasSecondaryColorTextTarget) {
      this.secondaryColorTarget.addEventListener("input", () => {
        this.secondaryColorTextTarget.value = this.secondaryColorTarget.value
      })
      this.secondaryColorTextTarget.addEventListener("input", () => {
        if (/^#[0-9A-Fa-f]{6}$/.test(this.secondaryColorTextTarget.value)) {
          this.secondaryColorTarget.value = this.secondaryColorTextTarget.value
        }
      })
    }
    if (this.hasAccentColorTarget && this.hasAccentColorTextTarget) {
      this.accentColorTarget.addEventListener("input", () => {
        this.accentColorTextTarget.value = this.accentColorTarget.value
      })
      this.accentColorTextTarget.addEventListener("input", () => {
        if (/^#[0-9A-Fa-f]{6}$/.test(this.accentColorTextTarget.value)) {
          this.accentColorTarget.value = this.accentColorTextTarget.value
        }
      })
    }
    // Add listeners for validation
    if (this.hasPrimaryColorTarget) this.primaryColorTarget.addEventListener("input", () => this.validateFields())
    if (this.hasSecondaryColorTarget) this.secondaryColorTarget.addEventListener("input", () => this.validateFields())
    if (this.hasAccentColorTarget) this.accentColorTarget.addEventListener("input", () => this.validateFields())
    if (this.hasLogoTarget) this.logoTarget.addEventListener("change", () => this.validateFields())
  }

  validateFields() {
    // Adjust required fields as needed for your branding step
    const requiredFields = [
      this.hasPrimaryColorTarget ? this.primaryColorTarget.value.trim() : "",
      this.hasSecondaryColorTarget ? this.secondaryColorTarget.value.trim() : "",
      this.hasAccentColorTarget ? this.accentColorTarget.value.trim() : ""
    ]
    // If logo is required, check for file presence
    const logoValid = this.hasLogoTarget ? (this.logoTarget.files && this.logoTarget.files.length > 0) : true
    const allFilled = requiredFields.every(val => val.length > 0) && logoValid
    if (this.hasContinueBtnTarget) {
      this.continueBtnTarget.disabled = !allFilled
    }
  }
}
